/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrLaunchBalloonDto } from '../../models/dbr-launch-balloon-dto';

export interface BalloonsControllerLaunch$Params {
  balloonCode: string;
      body: DbrLaunchBalloonDto
}

export function balloonsControllerLaunch(http: HttpClient, rootUrl: string, params: BalloonsControllerLaunch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerLaunch.PATH, 'post');
  if (params) {
    rb.path('balloonCode', params.balloonCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

balloonsControllerLaunch.PATH = '/balloons/launch/{balloonCode}';
